<script>
import { VIcon } from 'vuetify/lib'
import Themeable from 'vuetify/lib/mixins/themeable'
import Routable from 'vuetify/lib/mixins/routable'
import Sizeable from 'vuetify/lib/mixins/sizeable'

export default {
  name: 'EChip',
  directives: {
    Ripple: false,
  },
  mixins: [Sizeable, Routable, Themeable],
  props: {
    variant: { type: String, default: 'default' },
    prependIcon: { type: String, default: '' },
    appendIcon: { type: String, default: '' },
    closable: { type: Boolean, default: false },
    outlined: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    active: { type: Boolean, default: false },
    tag: {
      type: String,
      default: 'span',
    },
  },
  computed: {
    classes() {
      return {
        'e-chip': true,
        'e-chip--disabled': this.disabled,
        [`e-chip--${this.variant}`]: this.variant,
        'e-chip--outlined': this.outlined,
        'e-chip--closable': this.closable,
        'e-disabled': this.disabled,
        'e-active': this.active,
        ...this.sizeableClasses,
        ...this.themeClasses,
      }
    },
  },
  methods: {
    genContent() {
      return this.$createElement(
        'span',
        {
          staticClass: 'e-chip__content',
        },
        [this.$slots.default]
      )
    },
    genPrependIcon() {
      const data = {
        props: {
          // size: '14px',
        },
      }
      return this.$createElement(
        'span',
        {
          staticClass: `e-chip__prepend-icon`,
        },
        [this.$createElement(VIcon, data, this.prependIcon)]
      )
    },
    genAppendIcon() {
      const data = {
        props: {
          // size: '14px',
        },
      }
      return this.$createElement(
        'span',
        {
          staticClass: `e-chip__append-icon`,
        },
        [this.$createElement(VIcon, data, this.appendIcon)]
      )
    },
    genCloseButton() {
      const data = {
        props: {
          size: '14px',
        },
        // on: this.$listeners,
        on: {
          click: (e) => {
            this.$emit('click:close', e)
          },
        },
      }
      return this.$createElement(
        'span',
        {
          staticClass: `e-chip__close-button`,
        },
        [this.$createElement(VIcon, data, 'icon-close-sign')]
      )
    },
  },
  render(h) {
    let children = []
    if (this.prependIcon) {
      children.push(this.genPrependIcon())
    }
    children.push(this.genContent())
    if (this.appendIcon) {
      children.push(this.genAppendIcon())
    }
    if (this.variant === 'actionable' && this.closable) {
      children.push(this.genCloseButton())
    }

    let { tag, data } = this.generateRouteLink()
    data.on = this.$listeners
    data.attrs = {
      ...data.attrs,
      // tabindex: this.chipGroup && !this.disabled ? 0 : data.attrs.tabindex,
    }
    // data.directives.push({
    //   name: 'show',
    //   value: this.active,
    // })
    return h(tag, data, children)
  },
}
</script>
